import React, { useState } from "react";
import emailjs from "@emailjs/browser";

function Contact() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    description: "",
  });

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .send(
        "service_fc15lzs",
        "template_guasf3q",
        {
          firstName: formData.firstName,
          lastName: formData.lastName,
          email: formData.email,
          phone: formData.phone,
          description: formData.description,
        },
        "P6Xs8My-1auB5EQFC"
      )
      .then(() => alert("Message sent!"))
      .catch(() => alert("Something went wrong!"));

    setFormData({
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      description: "",
    });
  };

  return (
    <section
      id="contact"
      className="scroll-mt-24 py-16 px-4 sm:px-6"
      data-aos="fade-up"
    >
      {/* Heading */}
      <div className="text-center mb-12">
  <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-black">
    CONTACT US
  </h2>
  <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-purple-600 mx-auto mt-4"></div>
</div>

    

      {/* ⭐ TWO SEPARATE CONTAINERS SIDE BY SIDE ⭐ */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 max-w-7xl mx-auto">

        {/* LEFT CONTAINER → MAP */}
        <div
          className="bg-gradient-to-br from-gray-900 via-black to-gray-800 text-white 
          py-10 px-6 sm:px-8 lg:px-12 rounded-2xl shadow-2xl"
          data-aos="fade-right"
        >
          <h3 className="text-2xl font-bold mb-6">Our Office Location</h3>

          <div className="rounded-2xl overflow-hidden shadow-lg border border-gray-700">
           <div className="rounded-2xl overflow-hidden shadow-lg border border-gray-700">
  <iframe
    title="T-Hub Location"
    className="w-full h-[450px]"
    loading="lazy"
    allowFullScreen={true}
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.9464387042078!2d78.3788131!3d17.4339057!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb93bd18410b0f%3A0x8d7e3fea891858ce!2sT-Hub!5e0!3m2!1sen!2sin!4v1700000000000"
  ></iframe>

  {/* ⭐ Direction Button */}
  <a
    href="https://www.google.com/maps/dir/?api=1&destination=17.4339057,78.3788131"
    target="_blank"
    rel="noopener noreferrer"
    className="block mt-4 bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 text-center rounded-lg"
  >
    Get Directions from Current Location
  </a>
</div>

          </div>
        </div>

        {/* RIGHT CONTAINER → FORM */}
        <div
          className="bg-gradient-to-br from-gray-900 via-black to-gray-800 text-white 
          py-10 px-6 sm:px-8 lg:px-12 rounded-2xl shadow-2xl"
          data-aos="fade-left"
        >
          <h3 className="text-2xl font-bold mb-6">Send Us a Message</h3>

          <form onSubmit={handleSubmit} className="space-y-6">

            {/* Row 1 */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <input
                type="text"
                name="firstName"
                placeholder="First Name"
                value={formData.firstName}
                onChange={handleChange}
                required
                className="p-4 rounded-lg text-gray-900 w-full"
              />

              <input
                type="text"
                name="lastName"
                placeholder="Last Name"
                value={formData.lastName}
                onChange={handleChange}
                required
                className="p-4 rounded-lg text-gray-900 w-full"
              />
            </div>

            {/* Row 2 */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <input
                type="email"
                name="email"
                placeholder="Email Address"
                value={formData.email}
                onChange={handleChange}
                required
                className="p-4 rounded-lg text-gray-900 w-full"
              />

              <input
                type="tel"
                name="phone"
                placeholder="Phone Number"
                value={formData.phone}
                onChange={handleChange}
                required
                className="p-4 rounded-lg text-gray-900 w-full"
              />
            </div>

            {/* Message */}
            <textarea
              name="description"
              rows="4"
              placeholder="Your Message..."
              value={formData.description}
              onChange={handleChange}
              required
              className="p-4 rounded-lg text-gray-900 w-full"
            ></textarea>

            {/* Button */}
            <button
              type="submit"
              className="w-full bg-gradient-to-r from-blue-500 to-purple-600 
              py-3 rounded-lg text-lg font-semibold hover:scale-105 transition"
            >
              Send Message
            </button>
          </form>
        </div>

      </div>
    </section>
  );
}

export default Contact;
